import React, { useState } from "react";

import { Button } from "@fronterahealth/frontera-ui-components";

import { ReportPageLocationEnums } from "@api/graphql/types-and-hooks";
import { useCanRegenerateReportParts } from "@components/RegenerateReportPart/useCanRegenerateReportParts";

interface ConfirmGenerationDialogProps {
  type: ReportPageLocationEnums;
  promptDialogOpen: boolean;
  setPromptDialogOpen: (open: boolean) => void;
  skipNavigate?: boolean;
}

interface RegenerateReportPartButtonProps {
  show: boolean;
  pageLocation: ReportPageLocationEnums;
  ConfirmGenerationDialog: React.FC<ConfirmGenerationDialogProps>;
  disabled?: boolean;
}

export const RegenerateReportPartButton: React.FC<RegenerateReportPartButtonProps> = ({
  show,
  pageLocation,
  ConfirmGenerationDialog,
  disabled = false,
}) => {
  const [regenerateDialogOpen, setRegenerateDialogOpen] = useState<boolean>(false);
  const showRegenerate = useCanRegenerateReportParts();

  if (!show || !showRegenerate) return null;

  return (
    <>
      <Button
        appearance="secondary"
        text="Regenerate missed sections"
        disabled={disabled}
        className="mr-auto"
        onClick={() => setRegenerateDialogOpen(true)}
      />
      <ConfirmGenerationDialog
        type={pageLocation}
        promptDialogOpen={regenerateDialogOpen}
        setPromptDialogOpen={setRegenerateDialogOpen}
        skipNavigate
      />
    </>
  );
};
